import React from "react";

import {
  Swiper,
  SwiperSlide,
} from "swiper/react";

import {
  Autoplay,
  Pagination,
} from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

import "./Testimonials.css";

const testimonials = [
  {
    text: "Booked a Mumbai to Shirdi Cab with Sai Shirdi Cabs for Sai Baba Darshan. The driver arrived on time, the car was clean, and the entire journey was safe and comfortable. Highly recommended.",
    name: "Mr. Rahul Sharma",
    rating: 5,
  },
  {
    text: "We booked a Pune to Shirdi Taxi for our family pilgrimage. The driver was polite and experienced, and the journey was very smooth. Excellent service from Sai Shirdi Cabs.",
    name: "Mrs. Priya Desai",
    rating: 5,
  },
  {
    text: "Excellent Shirdi Cab Service. We travelled with our family in an Innova Crysta and had a very comfortable journey. The vehicle was clean and spacious.",
    name: "Mr. Amit Patil",
    rating: 5,
  },
  {
    text: "Our Nashik to Shirdi Cab booking was handled perfectly. The driver was punctual and helpful throughout the trip. We had a peaceful and hassle-free Sai Baba Darshan.",
    name: "Mrs. Sneha Kulkarni",
    rating: 5,
  },
  {
    text: "We booked an airport pickup and Shirdi pilgrimage trip with Sai Shirdi Cabs. The service was professional, the driver was friendly, and everything was arranged smoothly.",
    name: "Mrs. Kavita Joshi",
    rating: 5,
  },
  {
    text: "Very reliable taxi service for Shirdi. The booking process was simple, the driver reached on time, and the car was well maintained. I will definitely book again.",
    name: "Mr. Suresh Verma",
    rating: 5,
  },
];

const Rating = ({ rating }) => {
  return (
    <div className="rating">
      {[1, 2, 3, 4, 5].map((item) => (
        <span key={item}>
          {rating >= item ? "★" : "☆"}
        </span>
      ))}
    </div>
  );
};

function Testimonials() {
  return (
    <section className="testimonial-section">

      <div className="container">

        <div className="testimonial-top">

          <div className="testimonial-image">

            <img
              src="/images/girl-with-car.jpg"
              alt="Sai Shirdi Cabs Customer Service"
            />

          </div>

          <div className="testimonial-content">

            <div className="testimonial-title">

              <div className="title-lines">
                <span></span>
                <span></span>
                <span></span>
              </div>

              <h2>
                What Our Customers Say
              </h2>

            </div>

            <p>
              Thousands of devotees and travelers trust Sai Shirdi Cabs
              for comfortable and reliable taxi services to Shirdi.
              From Mumbai to Shirdi, Pune to Shirdi and Nashik to Shirdi,
              we provide clean cars, experienced drivers and safe journeys
              for Sai Baba Darshan, family trips, airport transfers and
              outstation travel.
            </p>

            <div className="review-users">

              <div className="users">

                <img
                  src="/images/users/user1.jpg"
                  alt="Sai Shirdi Cabs Customer"
                />

                <img
                  src="/images/users/user2.jpg"
                  alt="Sai Shirdi Cabs Customer"
                />

                <img
                  src="/images/users/user3.jpg"
                  alt="Sai Shirdi Cabs Customer"
                />

                <div className="more-users">
                  +
                </div>

              </div>

              <div>

                <Rating rating={5} />

                <span>
                  5000+ Happy Customers
                </span>

                <p>
                  Trusted for safe and comfortable Shirdi journeys
                </p>

              </div>

            </div>

          </div>

        </div>

        {/* TESTIMONIAL SLIDER */}

        <div className="testimonial-slider">

          <Swiper
            modules={[Autoplay, Pagination]}

            spaceBetween={25}

            slidesPerView={3}

            slidesPerGroup={1}

            loop={true}

            speed={800}

            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}

            pagination={{
              clickable: true,
            }}

            breakpoints={{
              0: {
                slidesPerView: 1,
                spaceBetween: 15,
              },

              768: {
                slidesPerView: 2,
                spaceBetween: 20,
              },

              1024: {
                slidesPerView: 3,
                spaceBetween: 25,
              },
            }}

            className="testimonial-swiper"
          >

            {testimonials.map((item, index) => (

              <SwiperSlide key={index}>

                <div className="testimonial-card">

                  <Rating rating={item.rating} />

                  <p>
                    {item.text}
                  </p>

                  <h4>
                    {item.name}
                  </h4>

                </div>

              </SwiperSlide>

            ))}

          </Swiper>

        </div>

      </div>

    </section>
  );
}

export default Testimonials;
